import { en } from './en';
import { ka } from './ka';
import { hy } from './hy';
import { ru } from './ru';
import { ky } from './ky';
import { kk } from './kk';

export const translations = {
  en,
  ka,
  hy,
  ru,
  ky,
  kk,
};

